import { CSSProperties, useEffect, useRef } from 'react';
type CalciteOverrideProps = {
  children: React.ReactElement;
  sx: CSSProperties;
};
const styleToString = (style: CSSProperties) =>
  Object.keys(style).reduce(
    (acc, key) =>
      acc +
      key
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase() +
      ':' +
      style[key as keyof CSSProperties] +
      ';',
    ''
  );
export const CalciteOverride = ({ children, sx }: CalciteOverrideProps) => {
  // get ref of child element
  const childRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const shadowRoot = childRef.current?.shadowRoot;

    if (!shadowRoot) {
      return;
    }

    // Override the styles of the shadow root element
    const style = document.createElement('style');
    style.textContent = `* {${styleToString(sx)}`;

    shadowRoot.append(style);

    return () => {
      style.remove();
    };
  }, [sx]);

  return <children.type ref={childRef} {...children.props} />;
};
